import { IconName } from "./icons";
import type { LinkData } from "./link";

export enum MenuSectionIndicator {
  Pill = "pill",
  None = "none",
}

export enum MenuSectionAlign {
  Top = "top",
  Center = "center",
}

/**
 * Sub-menu item containing headline, text, and links
 */
export interface SubMenuSection {
  /** List of links in this sub-menu section */
  indicator?: MenuSectionIndicator;
  align?: MenuSectionAlign;
  links: (LinkData & { icon?: IconName })[];
}

/**
 * Sub-menu containing multiple sub-menu items
 */
export interface SubMenu {
  /** Display label for the sub-menu trigger */
  label: string;
  /** Optional href — makes the trigger also a navigable link */
  href?: string;
  /** List of sub-menu items (sections) */
  items: SubMenuSection[];
}

/**
 * Menu item can be either a simple link or a sub-menu with nested items
 */
export type MenuItem =
  | { type: "link"; data: LinkData }
  | { type: "submenu"; data: SubMenu };

/**
 * Main menu structure
 */
export interface Menu {
  /** List of menu items (links or sub-menus) */
  items: MenuItem[];
}
